var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuDocument'),_c('Government_receipt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }